import React, { Component  } from 'react';
import '../css/Login.css';
import axios from 'axios';
import logo from '../images/logo.svg';
import { Redirect } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';



export default class AdminUpload extends Component
{
   constructor(props) {
      super(props);
      this.state ={
        username: '',
        password: '',
        isAdmin:false
      }
      this.onChangeUsername = this.onChangeUsername.bind(this)
      this.onChangePassword = this.onChangePassword.bind(this)
      this.onFormSubmit = this.onFormSubmit.bind(this)      
    }

    componentDidMount() {
            this.setState({ 
                isAdmin:false
            });
    }

    onChangeUsername(e) {
        this.setState ({
            username: e.target.value
        })
    }
    onChangePassword(e) {
        this.setState ({
            password: e.target.value
        })
    }
    onFormSubmit(e){
        e.preventDefault();
        let username = this.state.username;
        let password = this.state.password;
        const url = 'https://ikaemerce.faisalhakim.com/apilaravel/public/api/login';
        const formData = {email: username, password: password}
        return  axios.post(url, formData)
                .then(response => {
                    // toast("Login successfull")
                    if (response.status === 200) {
                        localStorage.setItem('existToken',response.data.success.token);
                        localStorage.setItem('token',response.data.success.token);
                    }
                })
                .then (
                    confirmAlert({
                        title: 'Login successfull',
                        message: 'Click OK to enter the panel admin',
                        buttons: [
                          {
                            label: 'Yes',
                            onClick: () => {
                                this.setState({ 
                                    isAdmin:true
                                })
                                window.location.href = 'https://ikaemerce.faisalhakim.com/admin'
                            }
                          }
                        ]
                    })
                )
                
                .catch(function (error) {
                    confirmAlert({
                        title: "",
                        message: "Login Failed, Username or password doesn't not match",
                        buttons: [
                          {
                            label: 'Ok',
                          }
                        ]
                    })
                })
       
    }
    
  
   render()
   {
      return(
        <div className="login jumbotron-fluid">
            {this.state.isAdmin ?  <Redirect  to="/admin" /> : ''}
            <div className="card mx-auto shadow ">
                <form onSubmit={this.onFormSubmit} >
                    <h3 className="title">IKAEMERCE Login</h3>
                    <a type="button" href='https://ikaemerce.faisalhakim.com'>
                        <img src={logo} className="img-fluid logo" alt="logo" />
                    </a>
                    <table className="mx-auto form-group">
                        <tbody>
                            <tr>
                                <td>E-mail</td>
                                <td className="tableSpace">:</td>
                                <td><input type="text" name="username" className="form-control" value={this.state.username} onChange={this.onChangeUsername}/></td>
                            </tr>
                            <tr>
                                <td>Password</td>
                                <td className="tableSpace">:</td>
                                <td><input type="password" name="password" className="form-control" value={this.state.password} onChange={this.onChangePassword}/></td>
                            </tr>
                        </tbody>
                    </table>
                    <button type="submit" className="btn btn-md btn-success mx-auto">Submit</button>
                </form>
            </div>
        </div>
      )
   }
}

